import React, { useState, useEffect } from "react";
import CasinoSuperskokPlacements from "./CasinoSuperskokPlacements.jsx";
import CasinoSuperskokResults from "./CasinoSuperskokResults.jsx";
import { Game } from "../../Game/Game.jsx";

export default function CasinoSuperskokTabs(props) {
    const [tabs, setTabs] = useState(['Nagrade', 'Trenutni poredak']);
    const [selectedTab, setSelectedTab] = useState('Nagrade');
    const [pravilaLink, setPravilaLink] = useState("");

    useEffect(() => {
        if (props.info) {
            setTabs(props.info.igreSifre == null ? ['Nagrade', props.info.uplaceno ? 'Pobjednici' : 'Poredak'] : ['Popis igara', 'Nagrade', props.info.uplaceno ? 'Pobjednici' : 'Poredak']);
            if (props.info.igreSifre == null) { setSelectedTab('Nagrade') } else { setSelectedTab('Popis igara') };
            setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);
        }

        switch (props?.kampanja) {
            case 'egt-digital-2025-07':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_EGT_Digital_7_7_2025.pdf`);
                break;
            case 'fazi-2025-07':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Fazi_21_7_2025.pdf`);
                break;
            case '7777-2025-08':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_7777Gaming_4_8_2025.pdf`);
                break;
            case 'fazi-2025-08':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Fazi_14_8_2025.pdf`);
                break;
            case 'egt-digital-2025-09':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_EGTDigital_28_8_2025.pdf`);
                break;
            case 'fazi-2025-09':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Fazi_12_9_2025.pdf`);
                break;
            case 'gamesglobal-2025-09':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_GamesGlobal_22_9_2025.pdf`);
                break;
            case 'egt-digital-2025-10':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_EGTDigital_1_10_2025.pdf`);
                break;
            case 'tech4bet-2025-10':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Tech4Bet_22_10_2025.pdf`);
                break;
            case 'fazi-2025-11':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Fazi_12_11_2025.pdf`);
                break;
            case 'expanse-2025-12':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Expanse_27_12_2025.pdf`);
                break;
            case 'tech4bet-2026-01':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Tech4Bet_01_2026.pdf`);
                break;
            case 'fazi-2026-02':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Fazi_9_2_2026.pdf`);
                break;
            case 'egt-digital-2026-02':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_EGTDigital_16_2_2026.pdf`);
                break;
            case 'egt-digital-2026-03':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_EGTDigital_23_3_2026.pdf`);
                break;
            case 'fazi-2026-04':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Fazi_6_4_2026.pdf`);
                break;
            case 'egt-digital-2026-05':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_EGTDigital_1_5_2026.pdf`);
                break;
            case 'amusnet-2026-07':
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Amusnet_8_7_2026.pdf`);
                break;
            default:
                setPravilaLink(`${casino.config.casinoCDNDocumentsUrl}/Pravila/SuperSkok_Fazi_9_9_2024.pdf`);
                break
        }
    }, [props.info]);

    useEffect(() => {
        if (props.rewardsTab && props.info) {
            setSelectedTab("Nagrade");
        } else if (props.gamesTab && props.info) {
            setSelectedTab("Popis igara")
        }
    }, [props.rewardsTab, props.info]);

    function getTotal() {
        let total = 0;
        props.info.nagradeLista.forEach((nagrada, index) => {
            if (index == 0 || (nagrada.mjesto - props.info.nagradeLista[index - 1].mjesto < 2)) {
                total = total + nagrada.iznos;
            }
            else {
                total = total + (nagrada.iznos * (nagrada.mjesto - props.info.nagradeLista[index - 1].mjesto));
            }
        });
        return total;
    }

    function getTotalPlaces() {
        return props.info.nagradeLista && props.info.nagradeLista[props.info.nagradeLista.length - 1].mjesto;
    }

    //function dohvatiIgre() {
    //    if (props.info.igreSifre == null) {
    //        return [];
    //    }
    //    var utrkaIgraSifreArray = props.info.igreSifre.split(',');

    //    return props.games.filter(function (igra) {
    //        if (utrkaIgraSifreArray.includes(igra.s))
    //            return igra;
    //    });
    //}

    function dohvatiIgre() {
        if (!props.info.igreSifre || !props.games) return [];

        const sifre = props.info.igreSifre.split(',');
        const igreMap = props.games.reduce((map, igra) => {
            map[igra.s] = igra;
            return map;
        }, {});

        return sifre.map(sifra => igreMap[sifra]).filter(Boolean);
    }



    function renderPopisIgara() {
        return <div>
            <div id="game-container" className="maximum margin-center">
                <br></br>
                <div id="games" className={"clearfix white games-container"} style={(props.games) ? { padding: '0px' } : {}} >
                    {!props.games && <div>Dohvaćanje igara...</div>}
                    {props.games && dohvatiIgre().map(renderIgra)}
                </div>
            </div>
        </div>
    }

    function renderIgra(igra, i) {
        return <Game
            brands={props.brands}
            categories={props.gameCategories}
            routePrefix={"/promotions/casino-superskok/" + props?.kampanja}
            key={igra.s} igra={igra}
            showJackpot={true}
            goLazyImage={true}
            fromNative={casino.config.fromNativeApp}
            fromNativeGameName={true}
            // GamePosition podaci, HizmanB
            PageName={`Promocije-{${props.kampanja}}`}
            GamePosition={i + 1}
            PositionType="lista_igara"
            IsIcon={false}
        />;
    }

    function goToTab(tab) {
        if (tab === "Popis igara") {
            setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);
        }
        setSelectedTab(tab);
    }
    return (
        <div className="casino-superskok-section">
            {props.info && <>
                <h2 id="rewards">Nagradni fond</h2>
                {props.kampanja != "super-travanj" && <h2 className="prize-fund-title">
                    <span className="red">
                        {casino.utils.numberWithCurrencyFromated(getTotal(), props.info.valuta)}</span> se dijeli na {getTotalPlaces()} najbolje rangiranih igrača.
                </h2>}
            </>}
            <div>
                <div className="segment v2" id="tabs">
                    {tabs && tabs.map((tab) =>
                        <button key={tab} onClick={() => goToTab(tab)} className={'segment--btn' + (selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                    )}
                </div>
                {selectedTab == 'Nagrade' && <CasinoSuperskokPlacements {...props} />}
                {(selectedTab == 'Trenutni poredak' || selectedTab == 'Pobjednici' || selectedTab == 'Poredak') && <CasinoSuperskokResults {...props} kampanja={props.kampanja} />}
                {selectedTab == 'Popis igara' && renderPopisIgara()}
            </div>
            <a className="btn-rules" target="_blank" href={pravilaLink + '?c=' + casino.config.guiCacheVerzija}>
                <span>Pravila igre</span>
            </a>
            <p className="bold" style={{ textAlign: 'center', color: '#aa0d19', fontSize: '14px' }}>Izmjenjena su pravila promocije.</p>
            <p className="res-info">*<i>rezultati se osvježavaju svakih 5 minuta</i></p>
        </div>
    )
}